import { useLanguage } from '../lib/i18n/context';
import { SUPPORTED_LANGUAGES } from '../lib/i18n/config';

export function LanguageSelector() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center text-sm">
      {SUPPORTED_LANGUAGES.map((lang, index) => (
        <div key={lang} className="flex items-center">
          <button
            onClick={() => setLanguage(lang)}
            className={`px-1.5 py-1 transition-colors ${
              lang === language
                ? 'text-primary-600 font-medium'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {lang.toUpperCase()}
          </button>
          {index < SUPPORTED_LANGUAGES.length - 1 && (
            <span className="text-gray-300">/</span>
          )}
        </div>
      ))}
    </div>
  );
}